"use client";

import { ErrorDisplay } from "@/components";

export default function ErrorPage() {
  // Create a generic error for the error display
  const error = new Error("An error occurred. Please try again.");

  return (
    <div className="min-h-screen">
      <ErrorDisplay error={error} />
    </div>
  );
}
